import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        operable: filters.operable,
        date:     Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'CMDBMonitoringLast13m',
        endpoint:           endpoints.cmdb.monitoringLast13m,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => [
            {
                name: 'withMonitoring',
                data: response.with_monitoring.map(i => ({y: i.amount, x: i.period * TIMESTAMP_MULTIPLY}))
            },
            {
                name: 'withoutMonitoring',
                data: response.without_monitoring.map(i => ({y: i.amount, x: i.period * TIMESTAMP_MULTIPLY}))
            }
        ]
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBMonitoringLast13m.js